"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react/require-default-props */
const react_1 = __importStar(require("react"));
const redux_1 = require("redux");
const react_i18next_1 = require("react-i18next");
const react_redux_1 = require("react-redux");
const controls_1 = require("~/components/common/controls");
const actions_1 = require("~/store/actions");
const selectors_1 = require("~/store/selectors");
const types_1 = require("~/store/types");
const UI_1 = require("~/components/UI");
const Address_1 = __importDefault(require("../Address"));
const DistributorProfileView_module_scss_1 = __importDefault(require("./DistributorProfileView.module.scss"));
const StatesInTerritory_1 = __importDefault(require("../StatesInTerritory"));
function DistributorProfileView({ editMode, isSubmitted, submitHandler, disableSubmit }) {
    var _a, _b, _c, _d;
    const { t } = (0, react_i18next_1.useTranslation)('profile');
    const { dispatchUpdateQuoteError, dispatchUpdateQuoteValue, dispatchFetchData } = (0, redux_1.bindActionCreators)({
        dispatchUpdateQuoteValue: actions_1.updateQuoteValue,
        dispatchUpdateQuoteError: actions_1.updateQuoteError,
        dispatchFetchData: actions_1.fetchData,
    }, (0, react_redux_1.useDispatch)());
    const user = (0, react_redux_1.useSelector)(selectors_1.selectCurrentUser);
    const company = (0, react_redux_1.useSelector)(selectors_1.selectCurrentUserDistributor);
    const address = (_a = user === null || user === void 0 ? void 0 : user.distributor) === null || _a === void 0 ? void 0 : _a.publicAddress;
    const [firstName, setFirstName] = (0, react_1.useState)();
    const [lastName, setLastName] = (0, react_1.useState)();
    const [phoneNumber, setPhoneNumber] = (0, react_1.useState)({ value: '', error: null });
    const [companyName, setCompanyName] = (0, react_1.useState)('');
    const [addressName, setAddressName] = (0, react_1.useState)('');
    const [addressLine, setAddressLine] = (0, react_1.useState)('');
    const [addressLine2, setAddressLine2] = (0, react_1.useState)();
    const [city, setCity] = (0, react_1.useState)('');
    const [state, setState] = (0, react_1.useState)('');
    const [zip, setZip] = (0, react_1.useState)('');
    const currentCountryId = (0, react_redux_1.useSelector)((0, selectors_1.selectQuoteEntry)(types_1.QUOTE_FIELDS.countryId));
    const countries = (0, react_redux_1.useSelector)(selectors_1.selectCountries);
    const states = (0, react_redux_1.useSelector)(selectors_1.selectStates);
    const statesForCountry = (0, react_redux_1.useSelector)((0, selectors_1.selectStatesOnCountryId)(currentCountryId.value));
    const currentState = statesForCountry.length > 0 && state !== ''
        ? statesForCountry.filter((stateForCountry) => stateForCountry.name === state)[0]
        : null;
    const countriesWithStates = [...new Set(states.map((st) => st.countryId))];
    (0, react_1.useEffect)(() => {
        dispatchFetchData();
    }, []);
    (0, react_1.useEffect)(() => {
        var _a, _b, _c, _d, _e, _f, _g;
        if (user) {
            setFirstName(user.firstName);
            setLastName(user.lastName);
            setCompanyName((_b = (_a = user.distributor) === null || _a === void 0 ? void 0 : _a.companyName) !== null && _b !== void 0 ? _b : '');
            setPhoneNumber({ value: (_c = user.phoneNumber) !== null && _c !== void 0 ? _c : '', error: phoneNumber.error });
        }
        if (address) {
            setAddressLine((_d = address.addressLine) !== null && _d !== void 0 ? _d : '');
            setAddressLine2((_e = address.addressLine2) !== null && _e !== void 0 ? _e : '');
            setCity(address.city);
            setState(address.state);
            setZip((_f = address.zip) !== null && _f !== void 0 ? _f : '');
            setAddressName((_g = address.name) !== null && _g !== void 0 ? _g : '');
            dispatchUpdateQuoteValue({ key: types_1.QUOTE_FIELDS.countryId, value: address.country_id });
        }
    }, [address, user]);
    (0, react_1.useEffect)(() => {
        if (isSubmitted && user && user.distributor && address) {
            submitHandler({ firstName, lastName, phoneNumber: phoneNumber.value, companyName }, Object.assign(Object.assign({}, address), { addressLine,
                addressLine2,
                city,
                state,
                zip, name: addressName, country_id: currentCountryId.value }), Object.assign(Object.assign({}, user.distributor), { companyName }));
        }
    }, [isSubmitted]);
    (0, react_1.useEffect)(() => {
        if (countriesWithStates.includes(currentCountryId.value)) {
            setState('');
        }
    }, [currentCountryId.value]);
    const phoneInputHandler = (key, value) => {
        setPhoneNumber({ value, error: phoneNumber.error });
    };
    const errors = {
        none: null,
        required: t('errors.phone-number'),
    };
    const phoneErrorHandler = (key, value) => {
        setPhoneNumber({ value: phoneNumber.value, error: errors[value] });
    };
    const quoteInputHandler = (key, value) => dispatchUpdateQuoteValue({
        key,
        value,
    });
    const quoteDropdownStateHandler = (key, value) => {
        var _a, _b;
        const selectedState = value ? (_b = (_a = states.find((stateOption) => stateOption.id === value)) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : '' : '';
        setState(selectedState);
        dispatchUpdateQuoteValue({
            key,
            value: selectedState,
        });
    };
    const inputErrorHandler = (key, type) => {
        dispatchUpdateQuoteError({
            key,
            error: type === types_1.INPUT_ERRORS.none ? null : t(`errors.${key}.${type}`),
        });
    };
    const getStateError = () => {
        var _a;
        if (((_a = currentState === null || currentState === void 0 ? void 0 : currentState.name) === null || _a === void 0 ? void 0 : _a.trim()) === '') {
            return 'State is required';
        }
        return null;
    };
    (0, react_1.useEffect)(() => {
        var _a, _b, _c, _d, _e, _f, _g;
        const hasProfileChanges = Boolean(user && address) &&
            [
                [firstName, user === null || user === void 0 ? void 0 : user.firstName],
                [lastName, user === null || user === void 0 ? void 0 : user.lastName],
                [phoneNumber.value, (_a = user === null || user === void 0 ? void 0 : user.phoneNumber) !== null && _a !== void 0 ? _a : ''],
                [companyName, (_c = (_b = user === null || user === void 0 ? void 0 : user.distributor) === null || _b === void 0 ? void 0 : _b.companyName) !== null && _c !== void 0 ? _c : ''],
                [addressName, (_d = address === null || address === void 0 ? void 0 : address.name) !== null && _d !== void 0 ? _d : ''],
                [addressLine, (_e = address === null || address === void 0 ? void 0 : address.addressLine) !== null && _e !== void 0 ? _e : ''],
                [addressLine2 !== null && addressLine2 !== void 0 ? addressLine2 : '', (_f = address === null || address === void 0 ? void 0 : address.addressLine2) !== null && _f !== void 0 ? _f : ''],
                [city, address === null || address === void 0 ? void 0 : address.city],
                [state, address === null || address === void 0 ? void 0 : address.state],
                [zip, (_g = address === null || address === void 0 ? void 0 : address.zip) !== null && _g !== void 0 ? _g : ''],
                [currentCountryId.value, address === null || address === void 0 ? void 0 : address.country_id],
            ].some(([currentValue, initialValue]) => currentValue !== initialValue);
        const hasInvalidProfileFields = [firstName, lastName, phoneNumber.value, addressLine, city, state, zip].some((field) => !(field === null || field === void 0 ? void 0 : field.trim())) ||
            Boolean(phoneNumber.error) ||
            !currentCountryId.value;
        disableSubmit(hasInvalidProfileFields || !hasProfileChanges);
    }, [
        address,
        addressLine,
        addressLine2,
        addressName,
        city,
        companyName,
        currentCountryId.value,
        disableSubmit,
        firstName,
        lastName,
        phoneNumber,
        state,
        user,
        zip,
    ]);
    return (react_1.default.createElement("div", { className: DistributorProfileView_module_scss_1.default.data },
        react_1.default.createElement("div", { className: DistributorProfileView_module_scss_1.default.userData },
            react_1.default.createElement("div", { className: DistributorProfileView_module_scss_1.default.info },
                t('info.first-name'),
                editMode ? (react_1.default.createElement(UI_1.Input, { type: "text", maxLength: 60, value: firstName, customErrors: { required: t('errors.first-name') }, onChange: setFirstName, onInput: setFirstName, required: true })) : (react_1.default.createElement("div", null, user === null || user === void 0 ? void 0 : user.firstName))),
            react_1.default.createElement("div", { className: DistributorProfileView_module_scss_1.default.info },
                t('info.last-name'),
                editMode ? (react_1.default.createElement(UI_1.Input, { type: "text", maxLength: 60, value: lastName, onChange: setLastName, onInput: setLastName, customErrors: { required: t('errors.last-name') }, required: true })) : (react_1.default.createElement("div", null, user === null || user === void 0 ? void 0 : user.lastName))),
            editMode ? (react_1.default.createElement("div", { className: DistributorProfileView_module_scss_1.default.info },
                t('info.company'),
                editMode ? (react_1.default.createElement(UI_1.Input, { type: "text", maxLength: 255, value: companyName, onChange: setCompanyName, onInput: setCompanyName })) : (react_1.default.createElement("div", null, user === null || user === void 0 ? void 0 : user.companyName)))) : null,
            react_1.default.createElement("div", { className: DistributorProfileView_module_scss_1.default.info },
                t('info.phone-number'),
                editMode ? (react_1.default.createElement(controls_1.PhoneNumberInput, { state: phoneNumber, inputKey: "phoneNumber", onInput: phoneInputHandler, onError: phoneErrorHandler, required: true })) : (react_1.default.createElement("div", null,
                    "+", user === null || user === void 0 ? void 0 :
                    user.phoneNumber)))),
        !editMode ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: DistributorProfileView_module_scss_1.default.companyData },
                react_1.default.createElement("div", { className: DistributorProfileView_module_scss_1.default.info },
                    t('info.company'),
                    react_1.default.createElement("div", null, company === null || company === void 0 ? void 0 : company.companyName)),
                react_1.default.createElement("div", { className: DistributorProfileView_module_scss_1.default.info },
                    t('company.email'),
                    react_1.default.createElement("div", null, company === null || company === void 0 ? void 0 : company.email)),
                react_1.default.createElement("div", { className: DistributorProfileView_module_scss_1.default.info },
                    t('company.phone'),
                    (company === null || company === void 0 ? void 0 : company.phoneNumber) ? react_1.default.createElement("div", null,
                        "+", company === null || company === void 0 ? void 0 :
                        company.phoneNumber) : null)),
            react_1.default.createElement("div", { className: DistributorProfileView_module_scss_1.default.companyData },
                address ? (react_1.default.createElement("div", { className: DistributorProfileView_module_scss_1.default.info },
                    t('company.address'),
                    react_1.default.createElement(Address_1.default, { address: Object.assign({}, address) }))) : null,
                ((_c = (_b = user === null || user === void 0 ? void 0 : user.distributor) === null || _b === void 0 ? void 0 : _b.states) === null || _c === void 0 ? void 0 : _c.length) ? (react_1.default.createElement("div", { className: DistributorProfileView_module_scss_1.default.info },
                    t('company.states-in-territory'),
                    react_1.default.createElement(StatesInTerritory_1.default, { statesInTerritory: user.distributor.states }))) : (react_1.default.createElement("div", { className: DistributorProfileView_module_scss_1.default.info },
                    t('company.states-in-territory'),
                    react_1.default.createElement("div", null, "N/D"))),
                react_1.default.createElement("div", { className: DistributorProfileView_module_scss_1.default.info })))) : (react_1.default.createElement("div", { className: DistributorProfileView_module_scss_1.default.editAddress },
            t('address-name'),
            react_1.default.createElement("div", { className: DistributorProfileView_module_scss_1.default.section },
                react_1.default.createElement(UI_1.Input, { type: "text", maxLength: 255, value: addressName, onChange: setAddressName, onInput: setAddressName, placeholder: t('placeholder.shipping-address.name') })),
            t('shipping-address'),
            react_1.default.createElement("div", { className: DistributorProfileView_module_scss_1.default.section },
                react_1.default.createElement(UI_1.Input, { type: "text", value: addressLine, onChange: setAddressLine, onInput: setAddressLine, placeholder: t('placeholder.shipping-address.street'), maxLength: 255, customErrors: { required: t('errors.street') }, required: true })),
            react_1.default.createElement("div", { className: DistributorProfileView_module_scss_1.default.section },
                react_1.default.createElement(UI_1.Input, { value: addressLine2, onChange: setAddressLine2, onInput: setAddressLine2, placeholder: t('placeholder.shipping-address.additional-line'), maxLength: 255 })),
            react_1.default.createElement("div", { className: DistributorProfileView_module_scss_1.default.section },
                react_1.default.createElement(UI_1.Input, { value: city, onChange: setCity, onInput: setCity, customErrors: { required: t('errors.city') }, placeholder: t('placeholder.shipping-address.city'), maxLength: 60, required: true })),
            react_1.default.createElement("div", { className: DistributorProfileView_module_scss_1.default.section }, statesForCountry.length === 0 ? (react_1.default.createElement(UI_1.Input, { value: state, onChange: setState, onInput: setState, customErrors: { required: t('errors.state') }, placeholder: t('placeholder.shipping-address.state'), maxLength: 60, required: true })) : (react_1.default.createElement(controls_1.FormDropdown, { inputKey: types_1.QUOTE_FIELDS.state, state: {
                    error: getStateError(),
                    value: currentState
                        ? {
                            key: currentState.id,
                            value: currentState.name,
                        }
                        : null,
                }, onInput: quoteDropdownStateHandler, onError: inputErrorHandler, options: statesForCountry
                    ? statesForCountry.map((stateForCountry) => ({
                        key: stateForCountry.id,
                        value: stateForCountry.name,
                    }))
                    : [], placeholder: t('placeholder.shipping-address.state'), required: true }))),
            react_1.default.createElement("div", { className: DistributorProfileView_module_scss_1.default.section },
                react_1.default.createElement(UI_1.Input, { value: zip, onChange: setZip, onInput: setZip, customErrors: { required: t('errors.zip') }, placeholder: t('placeholder.shipping-address.zip'), maxLength: 9, required: true })),
            countries && countries.length > 0 ? (react_1.default.createElement("div", { className: DistributorProfileView_module_scss_1.default.section },
                react_1.default.createElement(controls_1.FormDropdown, { inputKey: types_1.QUOTE_FIELDS.countryId, state: {
                        value: currentCountryId.value
                            ? {
                                value: countries.filter((country) => country.id === currentCountryId.value)[0].name,
                                key: currentCountryId.value,
                            }
                            : null,
                        error: t((_d = currentCountryId.error) !== null && _d !== void 0 ? _d : ''),
                    }, options: countries
                        ? [...countries]
                            .sort((a, b) => a.order - b.order)
                            .map((country) => ({
                            key: country.id,
                            value: country.name,
                        }))
                        : [], onInput: quoteInputHandler, onError: inputErrorHandler, placeholder: t('placeholder.shipping-address.country'), required: true }))) : null,
            react_1.default.createElement("div", { className: DistributorProfileView_module_scss_1.default.section })))));
}
exports.default = DistributorProfileView;
